import { Select, type SelectOption } from "./ui/Select";
import { useAppStore } from "../lib/store";
import { getThemeColors } from "../lib/theme";
import { trackEvent } from "../lib/analytics";
import { useTranslation } from "react-i18next";

const LANGUAGES: SelectOption[] = [
  { value: "en", label: "🇬🇧 EN" },
  { value: "de", label: "🇩🇪 DE" },
  { value: "es", label: "🇪🇸 ES" },
  { value: "fr", label: "🇫🇷 FR" },
  { value: "sl", label: "🇸🇮 SL" },
];

export function LanguageSelector() {
  const lang = useAppStore((state) => state.lang);
  const setLanguage = useAppStore((state) => state.setLanguage);
  const isDark = useAppStore((state) => state.isDark);
  const theme = getThemeColors(isDark);
  const { t } = useTranslation();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = e.target.value;
    trackEvent("global-language-selector", { language: newLang });
    setLanguage(newLang);
  };

  // TODO: make select be clickable on the span 'Lang'. Apperently not possible with Select but with button and list
  return (
    <div
      className={`flex items-center gap-2 px-2 sm:px-3 py-1 sm:py-1.5 h-8 ${theme.bgSecondary} rounded-lg ${theme.border} border`}
    >
      <Select
        value={lang}
        onChange={handleLanguageChange}
        options={LANGUAGES}
        aria-label={t("components.languageSelector.ariaLabel")}
        className={theme.text}
        optionClassName={theme.selectOption}
        data-testid="language-select"
      />
    </div>
  );
}
